import {
	WS_CONNECTED,
	WS_DISCONNECTED,
} from '../actions/websocket';
import { createReducer } from '@reduxjs/toolkit';


const initialState = {
	connected: false,
};

const ws = createReducer(initialState, {
	[WS_CONNECTED]: (state, action) => {
		state.connected = true;
	},
	[WS_DISCONNECTED]: (state, action) => {
		state.connected = false;
	},
});

export default ws;
